<template>
  <div class="deal-center d_flex flex_direction_col">
    <!-- 状态 -->
    <!-- <div :class="`pro-state ${stateColor(itemDetail.state)}`">
      {{ stateDesc }}
    </div> -->
    <!-- block-1 -->
    <div class="d_flex justify_content_sb flex_direction_col">
      <div class="main_block_1">
        <!-- 时间线 -->
        <div
          class="state-time-line c_1A1A1A"

        >
          <div>
            <span class="state-time-desc cell_label fz12" v-if="isShowCountDown&&diffTime"
              >距截止：</span
            >
            <!-- 倒计时 -->
            <div class="state-time-countdown" v-if="isShowCountDown&&diffTime">
              <span v-if="d" class="time-i">
                <em class="time-num fz24 font_w_bold">{{ d }}</em
                >天</span
              ><span class="time-i">
                <em class="time-num fz24 font_w_bold">{{ h }}</em
                >时</span
              ><span class="time-i"
                ><em class="time-num fz24 font_w_bold">{{ m }}</em
                >分</span
              ><span>
                <em class="time-num fz24 font_w_bold">{{ s }}</em
                >秒</span
              >
            </div>
            <!-- 时间文本 -->
            <span v-else class="state-time c_1A1A1A font_w_bold" >
              <span class="state-time-desc cell_label fz12"  v-if="itemDetail.state !=3" style="font-weight:400"><span v-if="itemDetail.state ==11||itemDetail.state ==5">报名截止：</span><span v-else>结束时间：</span></span>
              {{
              stateTime(itemDetail)
            }}</span>
          </div>
        </div>

        <!-- 项目展示价格（成交价，当前价） -->
        <div class="price_w">
          <div class="cell_row d_flex">
            <span class="cell_label fz12 c_1A1A1A">{{
              priceDesc(itemDetail.state)
            }}</span>
            <span class="fz12 c_CF3342">
              <el-tooltip
                effect="dark"
                :content="amountTran(itemDetail.project.currentPrice)"
                placement="top"
              >
                <em class="fz24 font_w_bold" style="margin: 0 5px">{{
                  formatMoney(itemDetail.project.currentPrice)
                }}</em>
              </el-tooltip>
            </span>
            <span class="fz12 c_CF3342">{{ itemDetail.priceUnitDesc }} </span>
            <!-- <span
              v-if="itemDetail.priceUnit === 'zongjia'"
              class="fz12 c_CF3342"
              >（总价）
            </span> -->
          </div>
        </div>
      </div>
      <!-- block-2 -->
      <div class="main_block_2 flex_direction_col bc_e6e6e6">
        <div class="block-outer">
          <div class="block-inner">
            <!-- 立即报名 -->

            <div
              v-if="isShowApplyBtn"
              class="d_flex align_item_c location_top"
              style="margin-top: 18px"
            >
              <div
                class="pay_margin fz12 text_center c_fff"
                :class="itemDetail.margin ? 'allow_buy' : 'bc_ccc'"
                @click="onApplyClick"
              >
                <template v-if="isDeposit">
                  <div>
                    <span v-if="!this.isLogin">（您未登录）</span>立即报名
                  </div>
                  <div class="" style="margin-left: 3px; margin-top: 3px">
                    交易保证金￥{{ formatMoney(itemDetail.margin) || 0 }}&nbsp;
                  </div>
                </template>
                <template v-else>
                  <span>立即报名</span>
                </template>
              </div>
            </div>
            <div
              v-if="isShowApplyBtn"
              class="paid_login02 x_y_center fz12 letter_spacing_1"
            >
              <img
                src="@/assets/images/tip_icon.png"
                alt=""
                style="margin-right: 2px"
              />
              提醒：您还没有报名，报名成功后才能参与遴选。
            </div>
            <!-- 备注 -->
            <div class="state-remark" v-if="isShowStateRemark">
              {{ stateRemark }}
            </div>
          </div>
        </div>
      </div>
      <!-- block-3 -->
      <div class="main_block_3 d_flex fz12">
        <span class="cell_i c_808080"
          ><em class="fz16 c_1A1A1A">{{
            itemDetail.statis.onlookerCnt || 0
          }}</em
          >次围观</span
        >
        <span class="cell_i c_808080"
          ><em class="fz16 c_1A1A1A">{{ itemDetail.statis.applyCnt || 0 }}</em
          >人报名</span
        >
      </div>
    </div>
    <!-- block-4 -->
    <div class="main_block_4 fz12 c_808080">
      <div class="cell_row d_flex flex_wrap">
        <div class="" style="flex: 0.33">
          <span>交易保证金：</span>
          <el-tooltip
            effect="dark"
            :content="amountTran(itemDetail.margin)"
            placement="top"
          >
            <span>￥{{ numTranFloat(itemDetail.margin) }}</span>
          </el-tooltip>
        </div>
      </div>
    </div>

    <AgreementRead
      v-model="agreementReadModal"
      :content="applyAgreementData.content"
      :title="applyAgreementData.title"
      @onCancal="onCancalAgreement"
      @onConfirm="onConfirmAgreement"
    />
  </div>
</template>

<script>
import { project_beat_time } from "@/api/action";
import { mapGetters, mapActions } from "vuex";
import {
  formatDate,
  tranTimeFormat,
  confirmCallBack,
  numTurnText,
  uuid,
  amountTran,
  numTranFloat,
} from "@/utils";
import Cookies from "js-cookie";

import { MySocket } from "@/utils/webSocket";
import { TradeModeText, ModeTrade } from "@/enums";
import AgreementRead from "@/components/template/AgreementRead.vue";
import { auction_checkNotice, cms_code_article_info } from "@/api/portal";

export default {
  components: {
    AgreementRead,
  },
  props: {
    itemDetail: {
      type: Object,
      default: () => {},
    },
    reqInfoTime: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      diffTime: null, //时间差值（用于计算倒计时）
      countDownTimer: null,
      pollIntervalTimer: null,
      pollInterval: 1000 * 30, //轮询间隔
      webSocket: null,
      agreementReadModal: false,
      applyAgreementData: {},
    };
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "cmsNoticeNode",
      "userinfo",
      "priceUnitKey",
      "stateAllKey",
    ]),
    amountTran: function () {
      return function (num) {
        return amountTran(num);
      };
    },
    numTranFloat: function () {
      return function (num) {
        return numTranFloat(num);
      };
    },
    // 是否需要缴纳保证金
    isDeposit() {
      return this.itemDetail.deposit === 1;
    },
    // 是否未开始
    isAdvancing() {
      return this.itemDetail.state === 3;
    },
    //格式化金额（小数点）
    formatMoney: function () {
      return function (num) {
        return Number(num).toLocaleString();
      };
    },
    // 是否已过报名时间
    isApplyTimeExpired() {
      return (
        new Date().getTime() > new Date(this.itemDetail.applyEndTime).getTime()
      );
    },
    // 是否已过确认截止时间
    isIntentionEndTimeExpired() {
      return (
        new Date().getTime() > new Date(this.itemDetail.intentionEndTime).getTime()
      );
    },
    // 价格描述
    priceDesc() {
      return function (state) {
        let text = "";
        switch (state) {
          case 4:
            text = "成交价格：";
            break;
          default:
            text = "挂牌价格：";
            break;
        }
        return text;
      };
    },
    // 状态
    stateDesc() {
      return this.stateAllKey[this.itemDetail.project.tradeMode][
        this.itemDetail.state
      ];
    },
    // 状态颜色
    stateColor() {
      return function (state) {
        let text = "";
        switch (state) {
          case 5:
            text = "bc_22D179";
            break;
          case 6:
            text = "bc_EF3946";
            break;
          case 1:
          case 3:
          case 4:
          case 7:
          case 8:
          case 10:
            text = "bc_808080";
            break;
          case 11:
            text = "bc_FFB03F";
            break;
        }
        return text;
      };
    },
    // 状态时间文本
    stateTimeDesc() {
      return function (state) {
        let text = "";
        switch (state) {
          case 4:
          case 7:
          case 8:
          case 10:
            text = "结束时间";
            break;
          case 5:
            text = "";
            break;
          case 6:
            // if(new Date().getTime() < new Date(this.itemDetail.applyStartTime).getTime()){
            //   text = '距开始'
            // }else{
            //   text = "距结束";
            // }
            text = "距结束";
            break;
        }
        return text;
      };
    },
    // 状态时间线
    stateTime() {
      return function (data) {
        let text = "";
        switch (data.state) {
          case 5:
          case 6:
            text = data.applyEndTime;
            break;
          case 4:
          case 7:
          case 8:
          case 10:
            text = data.stateEndTime;
            break;
          case 11:
            text = data.applyEndTime;
            break;
        }
        return text;
      };
    },
    // 是否已报名
    isApply() {
      return this.itemDetail.isApply;
    },
    tradeModeText() {
      return TradeModeText[this.itemDetail.project.tradeMode];
    },
    // 状态备注
    stateRemark() {
      let text = "";
      switch (this.itemDetail.state) {
        case 3:
          text = "待合同签署";
          break;
        case 5:
          if (this.isApply) {
            text = "您已报名该项目,待遴选";
          } else {
            text = "待遴选";
          }
          break;
        case 6:
          text = "待意向人确认";
          break;
        case 4:
          text = "项目已交易";
          break;
        case 11:
          text = "项目立项审核中，待转让方筛选符合条件的指定意向人";
          break;
        default:
          text = this.itemDetail.stateRemark;
      }
      return text;
    },
    // 是否显示状态备注
    isShowStateRemark() {
      return (
        [3, 4, 5, 6, 7, 8, 10, 11].includes(this.itemDetail.state) &&
        !this.isShowApplyBtn
      );
    },
    // 是否显示报名按钮
    isShowApplyBtn() {
      return [5].includes(this.itemDetail.state) && !this.isApply&&!this.isApplyTimeExpired;
    },
    // 是否显示倒计时
    isShowCountDown() {
      return [5,6].includes(this.itemDetail.state)&&(
        !this.isApplyTimeExpired||!this.isIntentionEndTimeExpired)
    },
    // 天
    d() {
      return Math.floor(this.diffTime / (1000 * 60 * 60) / 24);
    },
    // 时
    h() {
      return Math.floor((this.diffTime / (1000 * 60 * 60)) % 24);
    },
    // 分
    m() {
      return Math.floor((this.diffTime / (1000 * 60)) % 60);
    },
    // 秒
    s() {
      return Math.floor((this.diffTime / 1000) % 60);
    },
    // 项目是否已结束
    isEnd() {
      return [4, 7, 8, 10].includes(this.itemDetail.state);
    },
    // 是否待确认并且未到确认开始时间
    isNotStartedAnd6() {
      return (
        this.itemDetail.state === 6 &&
        new Date().getTime() <
          new Date(this.itemDetail.applyStartTime).getTime()
      );
    },
    // socket订阅地址
    subscribeUrl() {
      return "/topic/auction/" + this.itemDetail.project.projectNo;
    },
  },
  watch: {
    diffTime(n) {
      if (n <= 0) {
        this.diffTime = 0;
        clearInterval(this.countDownTimer);
      }
    },
    isEnd: {
      handler(n) {
        if (n) {
          clearInterval(this.countDownTimer);
          clearInterval(this.pollIntervalTimer);
        } else {
          this.initWebsocket();
        }
      },
      immediate: true,
    },
  },
  async created() {
    if (this.isShowCountDown) {
      this.computedDiffTime();
      this.startCountDown();
      this.startPollInterval();
      this.pageVisibilitychange();
    }
    // this.getApplyAgreement()
  },
  mounted() {},
  methods: {
    ...mapActions({
      initNoticeNode: "cache/initNoticeNode",
    }),
    // 缴纳保证金报名 click
    onApplyClick() {
      if (!this.isLogin) {
        this.$router.push({
          name: "login",
          query: {
            returnUrl: this.$route.fullPath,
          },
        });
        return;
      }
      // 弹出报名协议
      this.goApply();
      // this.agreementReadModal = true
    },
    // 跳转报名页
    goApply() {
      this.$router.push({
        name: "tradeApply",
        query: {
          projectNo: this.itemDetail.project.projectNo,
          tradeMode: this.itemDetail.project.tradeMode,
          margin: this.itemDetail.margin,
          title: this.itemDetail.title,
          transferMode: this.itemDetail.project.transferModeName,
        },
      });
    },
    // 获取项目公告
    async getProNotice() {
      let { data } = await auction_checkNotice({
        projectNo: this.itemDetail.project.projectNo,
      });
    },
    // 开启倒计时
    startCountDown() {
      clearInterval(this.countDownTimer);
      this.countDownTimer = setInterval(() => {
        if (this.diffTime < 0) {
          clearInterval(this.countDownTimer);
        }
        this.diffTime -= 1000;
      }, 1000);
      console.log('this.diffTime',this.diffTime)
    },
    // 计算时差
    computedDiffTime(countdownTime) {
      this.diffTime = countdownTime || this.itemDetail.countdownTime;
    },
    // 校准倒计时
    async checkCountDown() {
      let { data } = await project_beat_time({
        projectNo: this.itemDetail.projectNo,
        uid: uuid(13),
      });
      this.diffTime = data.countdownTime;
      this.startCountDown();
    },
    // 开启轮询
    startPollInterval() {
      clearInterval(this.pollIntervalTimer);
      this.pollIntervalTimer = setInterval(async () => {
        this.checkCountDown();
      }, this.pollInterval);
    },
    // 页面可见 change
    pageVisibilitychange() {
      window.addEventListener("visibilitychange", this.handlePage);
    },
    // 处理页面显示
    handlePage() {
      if (!document.hidden) {
        // 状态判断：显示（切换到当前页面）
        if (this.isShowCountDown) {
          this.checkCountDown();

        }
      }
    },
    // 初始websocket
    initWebsocket() {
      this.webSocket?.doUnSubscribes();
      this.webSocket = new MySocket({
        url: process.env.VUE_APP_WS_API,
      });
      this.webSocket.doConnect().then(() => {
        this.webSocket.doSubscribe(this.subscribeUrl, (msg) => {
          this.socketRes = JSON.parse(msg.body);
          this.onHandleWsEvent(this.socketRes.event);
        });
      });
      window.addEventListener("online", this.handleOnline);
      window.addEventListener("offline", this.handleOffline);
    },
    // 处理竞拍socket响应的事件
    onHandleWsEvent(eventKey) {
      switch (eventKey) {
        case "stateChange":
          this.handleStateChange();
          break;
        case "delayed":
          this.handleDelayed();
          break;
        case "end":
          this.handleEnd();
          break;
      }
    },
    //处理-项目状态
    handleStateChange() {
      this.itemDetail.state = this.socketRes.state - 0;
      if(this.itemDetail.state == 6){
        this.checkCountDown()
      }
      this.computedDiffTime(this.socketRes.countdownTime);
      this.startCountDown();
    },
    //处理-项目延时
    handleDelayed() {
      this.computedDiffTime(this.socketRes.countdownTime);
      this.startCountDown();
    },
    //处理-项目结束
    handleEnd() {
      this.itemDetail.state = this.socketRes.state - 0;
      this.itemDetail.stateEndTime = this.socketRes.endTime;
      this.itemDetail.remark = this.socketRes.remark;
      this.itemDetail.stateRemark = this.socketRes.remark;
    },
    // 获取报名协议
    async getApplyAgreement() {
      let { data } = await cms_code_article_info({
        code: "apply_agreement",
      });
      this.applyAgreementData = data;
    },
    // 取消报名协议
    onCancalAgreement() {
      this.agreementReadModal = false;
    },
    // 同意报名协议
    onConfirmAgreement() {
      this.goApply();
    },
  },
  destroyed() {
    this.webSocket?.doUnSubscribes();
    clearInterval(this.countDownTimer);
    clearInterval(this.pollIntervalTimer);
    window.removeEventListener("visibilitychange", this.handlePage);
  },
};
</script>

<style lang="scss" scoped>
.allow_buy {
  background-color: #0983cc;
  cursor: pointer !important;
}
.pay_margin {
  margin-top: 20px;
  width: 240px;
  padding: 6px 34px;
  cursor: not-allowed;
}
.paid_login02 {
  margin: 0px 0 0 0;
  padding: 5px 0px 5px 2px;
  background-color: #fefee4;
  color: rgb(136, 135, 135);
}
.deal-center {
  overflow: hidden;
  position: relative;
  width: 440px;
  margin: 0 10px;
  border: 1px solid #e6e6e6;
  .pro-state {
    position: absolute;
    top: 0;
    right: 0;
    width: 100px;
    height: 100px;
    line-height: 170px;
    transform: translate(50px, -50px) rotateZ(45deg);
    text-align: center;
    color: #fff;
    font-size: 12px;
  }
}
.location_top {
  position: relative;
  top: -4px;
}
.state-time-line {
  margin: 10px 0;
  .state-time-countdown {
    display: inline-block;
  }
}
.price_w {
  margin: 10px 0;
  & > span {
    &:first-child {
      margin: 0 18px 0 0;
    }
  }
}
.state_end_desc {
  margin: 0 0 12px 0;
  & > img {
    margin: 0 14px 0 0;
  }
}
.main_block_2 {
  height: 140px;
  .block-outer {
    display: flex;
    justify-content: center;
    height: 100%;
    .block-inner {
      align-items: center;
      .apply-btn {
        border-radius: 0;
        color: #fff !important;
        &:hover,
        &:focus {
          background-color: rgba($color: #0983cc, $alpha: 0.9);
        }
        &.is-disabled {
          color: #fff !important;
          background-color: #999 !important;
        }
      }
      .state-remark {
        padding: 0 50px;
        margin-top: 65px;
        text-align: center;
        line-height: 22px;
        color: #666;
      }
    }
  }
}
.main_block_1 {
  position: relative;
  min-height: 100px;
  padding: 10px;
  box-sizing: border-box;
  .cell_label {
    display: inline-block;
    min-width: 60px;
    white-space: nowrap;
    text-align: right;
  }
  .time-i {
    margin: 0 4px 0 0;
  }
  .time-num {
    margin: 0 5px;
  }
  .tradeMode-text {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 12px;
    background-color: #0983cc;
    color: #fff;
    padding: 4px 10px;
  }
}
.main_block_3 {
  .cell_i {
    height: 32px;
    line-height: 32px;
    flex: 1;
    text-align: center;
    border-bottom: 1px solid #e6e6e6;
    &:last-child {
      border-left: 1px solid #e6e6e6;
    }
  }
}
.cell_row {
  margin: 10px 0;
  align-items: baseline;
}
.main_block_4 {
  padding: 0 20px;
  .cell_row {
    margin: 10px 0;
  }
}
</style>
